import { PageBlockEditorModelV2 } from "../page-block-v2";
import { PageBlockColorV2 } from "./documentation-block-v2";
import { z } from "zod";
export const PageSectionTypeV2 = z.enum(["Tabs"]);
export const PageSectionColumnV2 = z.object({
    id: z.string(),
    blocks: z.array(PageBlockEditorModelV2),
});
export const PageSectionItemV2 = z.object({
    id: z.string(),
    title: z.string(),
    columns: z.array(PageSectionColumnV2),
});
export const PageSectionPaddingV2 = z.object({
    top: z.number().optional(),
    bottom: z.number().optional(),
    left: z.number().optional(),
    right: z.number().optional(),
});
export const PageSectionAppearanceV2 = z.object({
    expandToEdges: z.boolean(),
    contentExpandToEdges: z.boolean(),
    backgroundColor: PageBlockColorV2.optional(),
    foregroundColor: PageBlockColorV2.optional(),
    padding: PageSectionPaddingV2.optional(),
});
export const PageSectionEditorModelV2 = z.object({
    id: z.string(),
    type: z.literal("Section"),
    variantId: z.string().optional(),
    sectionType: PageSectionTypeV2,
    appearance: PageSectionAppearanceV2,
    items: z.array(PageSectionItemV2),
});
